// Response schemas for task comments (plan §4 GET/POST /tasks/:taskId/comments).
import { z } from 'zod';
import { SHOWN_TEXT_MAX } from './verification.ts';

// People type up to 4,000 characters; a team reader gets Leads ids redacted, which can make the
// text longer (see SHOWN_TEXT_MAX).
const MAX_BODY = SHOWN_TEXT_MAX;
const MAX_NAME = SHOWN_TEXT_MAX;
const MAX_PAGE_SIZE = 100;

export const commentSchema = z.object({
  id: z.number().int().positive(),
  body: z.string().max(MAX_BODY),
  author: z.object({ id: z.number().int().positive(), displayName: z.string().max(MAX_NAME) }),
  createdAt: z.string(),
  canDelete: z.boolean(),
});

export const commentPageSchema = z.object({
  items: z.array(commentSchema),
  page: z.number().int().positive(),
  pageSize: z.number().int().positive().max(MAX_PAGE_SIZE),
  total: z.number().int().nonnegative(),
});

export type Comment = z.infer<typeof commentSchema>;
export type CommentPage = z.infer<typeof commentPageSchema>;
